/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const file_contract_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5 5h5.5M5 8h8.5M5 19h6.5m1.5 4H2.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h10.036a1 1 0 0 1 .764.354l4.963 5.866a1 1 0 0 1 .237.646m-1.637 9.312-.591 5.098a.61.61 0 0 0 .322.654.63.63 0 0 0 .73-.11l1.701-1.675 1.702 1.675a.63.63 0 0 0 .729.11.61.61 0 0 0 .323-.654l-.598-5.131m-2.181.75c1.933 0 3.5-1.544 3.5-3.448S20.933 11 19 11s-3.5 1.543-3.5 3.447c0 1.904 1.567 3.448 3.5 3.448Z"
    />
  </svg>
)
export default file_contract_medium
